import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const TopLoader = () => {
  const location = useLocation();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  // Trigger loading when location changes
  useEffect(() => {
    setVisible(true);
    setProgress(0);

    // Fake loading animation for smoothness
    const start = setTimeout(() => setProgress(60), 150); // begin
    const finish = setTimeout(() => {
      setProgress(100);
      setTimeout(() => {
        setVisible(false);
        setProgress(0);
      }, 300); // fade out
    }, 600);

    return () => {
      clearTimeout(start);
      clearTimeout(finish);
    };
  }, [location.pathname]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "3px",
        width: progress + "%",
        backgroundColor: "#47B4E7", // your SKIEN theme color
        transition: "width 0.3s ease",
        opacity: visible ? 1 : 0,
        pointerEvents: "none",
        zIndex: 9999,
      }}
    />
  );
};

export default TopLoader;